export const URL = {
  LOGIN: "/api/v1/Users/MobileLogin",
  PhleboProfileData: "api/v1/HomeCollectionMobileApp/PhleboProfileData",
  CUSTOMERCARE_UPDATE: "/api/v1/CustomerCare/updatestatus",
  UPDATE_HCDATA: "/api/v1/HomeCollectionMobileApp/UpdateMobileHCData",
  SAVE_NEWPATIENT: "/api/v1/HomeCollectionMobileApp/SaveMobilePatient",
  GET_FILEURL: "/api/v1/CommonController/GetFileUrl",
  GET_DOCUMENT: "/api/v1/CommonController/GetDocument",
  UPLOAD_DOCUMENT: "/api/v1/CommonController/UploadDocument",
  BIND_SINGLE_TESTDATA_HOMECOLLECTION:
    "/api/v1/CustomerCare/BindSingleTestDataHomeCollection",
  BIND_TEST_FOR_APPLIEDCOUPON: "/api/v1/CouponMaster/BindTestForAppliedCoupon",
  HOMECOLLECTION_SEARCH_GETDATA: "/api/v1/HomeCollectionMobileApp/SyncAllData",
  HOMECOLLECTION_EDIT_APPOINTMENT:
    "/api/v1/HomeCollectionMobileApp/EditMobileAppointment",
  HOMECOLLECTION_SEARCH_BINDITEMDETAIL:
    "/api/v1/HomeCollectionMobileApp/BindMobileItemDetail",
  BIND_OLD_PATIENT: "/api/v1/HomeCollectionMobileApp/BindMobileOldPatient",
  GETINVESTIGATION:
    "/api/v1/HomeCollectionMobileApp/BindHomeCollectionTestData",
};
